import { useQuery } from '@tanstack/react-query';
import { fetchUsers } from '../services/users';
import type { AdminUser, ListParams, UserListResponse } from '../types/users.types';

export const userKeys = {
    all: ['users'] as const,
    lists: () => [...userKeys.all, 'list'] as const,
    list: (params: ListParams) => [...userKeys.lists(), params] as const,
    detail: (id: string) => [...userKeys.all, 'detail', id] as const,
    roles: (id: string) => [...userKeys.all, id, 'roles'] as const,
    permissions: (id: string) => [...userKeys.all, id, 'permissions'] as const,
};

interface UsersQueryData {
    users: AdminUser[];
    meta: UserListResponse['meta'];
}

export const useUsersQuery = (params: ListParams = {}) => {
    return useQuery<UserListResponse, Error, UsersQueryData>({
        queryKey: userKeys.list(params),
        queryFn: () => fetchUsers(params),
        select: (response) => ({
            users: response.data,
            meta: response.meta,
        }),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
